import React from 'react'
import PropTypes from 'prop-types'
import NavLink from 'react-router-dom/NavLink'

SubMenuItem.propTypes = {
    item: PropTypes.object.isRequired
}

function SubMenuItem(props) {
    const {item, handleClick} = props
    const {title, fa, icon, href, target = ''} = item

    return (
        <li className={`MenuItem ${title}`}>
            {
                fa &&
                <span className="IconHolder" data-tooltip={title}><i className={fa}/></span>
            }
            {
                icon &&
                <div className="ImageWrapper">
                    <img src={icon} alt="brand" className="BrandIcons"/>
                </div>
            }
            <NavLink onClick={handleClick} to={{pathname: href}} target={target} activeClassName="active"
                     className="nav-link">
                {title}
            </NavLink>
        </li>
    )
}

export default SubMenuItem
